import toastr from 'toastr'
import { funcModal } from 'components/modals'
import { helper } from 'services'

const components = {
    funcModal
}

const filters = {
}

const computed = {
}

const methods = {
    open (reservation, activeHistory, form) {
        this.reservation = reservation;
        this.activeHistory = activeHistory;
        this.form = form;
        this.with_refund = 1;
        this.$refs.modal.open();
    },

    onClose () {
        this.$emit('close');
    },
    submit () {
        this.processing = true;
        this.errors = {};
        this.recalculationRoomsItems();
        this.form['with_refund'] = Number(this.with_refund);
        const data = this.getFormDataWithTpsTypeId();
        this.$store.dispatch('reservations.update', {id: this.$route.params.id, data}).then(() => {
            this.processing = false;
            let errors = _.cloneDeep(this.$store.state.reservations.errors);
            if (errors) {
                toastr.error(errors.message);
                this.errors = errors.errors;
            } else {
                toastr.success("Reservation has been updated successfully.");
                this.$refs.modal.close();
            }
        })
    },

    getFormDataWithTpsTypeId () {
        const data = _.cloneDeep(this.form);

        if (Array.isArray(data.items)) {
            data.items = data.items.map((item) => {
                if (item.type === 'parking') {
                    const source = _.find(this.activeHistory.dates, (date) => date.id === item.id) || item;
                    item.type_id = helper.resolveTpsParkingTypeId(source, item.type_id);
                }
                return item;
            });
        } else if (data.items && data.items.parking) {
            const source = _.find(this.activeHistory.dates, (date) => date.id === data.items.parking.id) || data.items.parking;
            data.items.parking.type_id = helper.resolveTpsParkingTypeId(
                Object.assign({}, source, { type_type: 'parking' }),
                data.items.parking.type_id
            );
        }

        return data;
    },

    recalculationRoomsItems() {
        this.form.items = _.map(this.form.items, (item) => {
          if (item.type == 'room') {
            item.guest_names = _.slice(item.guest_names, 0, Number(item.number_of_rooms));
            item.guests_in_rooms = _.slice(item.guests_in_rooms, 0, Number(item.number_of_rooms));
          }
          return item;
        });
      },
}

export default {
    name: 'update-reservation-modal',
    methods,
    computed,
    components,
    filters,
    data () {
        return {
            errors: {},
            reservation: null,
            activeHistory: null,
            with_refund: 1,
            processing: false,
            form: {},
        }
    }
}